var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1004_228075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.7857,
    cy: 27.9425,
    r: 17.9327,
    fill: "#F7CE6C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3402 30.9617H21.1347C20.7916 30.9617 20.5071 30.6771 20.5071 30.334V23.6391C20.5071 21.4466 22.2896 19.6641 24.4822 19.6641H32.0139C32.357 19.6641 32.6416 19.9486 32.6416 20.2917V28.6603C32.6416 29.9323 31.6122 30.9617 30.3402 30.9617ZM21.7624 29.7064H30.3402C30.9176 29.7064 31.3863 29.2377 31.3863 28.6603V20.9194H24.4822C22.9842 20.9194 21.7624 22.1412 21.7624 23.6391V29.7064Z",
    fill: "#1D244A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3614 35.982H34.5245C34.1814 35.982 33.8968 35.6975 33.8968 35.3544C33.8968 34.7769 33.4282 34.3083 32.8508 34.3083C32.2733 34.3083 31.8047 34.7769 31.8047 35.3544C31.8047 35.6975 31.5202 35.982 31.177 35.982H27.8296C27.4865 35.982 27.202 35.6975 27.202 35.3544C27.202 34.7769 26.7333 34.3083 26.1559 34.3083C25.5785 34.3083 25.1098 34.7769 25.1098 35.3544C25.1098 35.6975 24.8253 35.982 24.4822 35.982H23.6453C21.913 35.982 20.5071 34.5761 20.5071 32.8438V30.3332C20.5071 29.9901 20.7916 29.7056 21.1347 29.7056H30.3402C30.9176 29.7056 31.3863 29.2369 31.3863 28.6595V22.8015C31.3863 22.4584 31.6708 22.1738 32.0139 22.1738H33.5537C34.3822 22.1738 35.1438 22.6174 35.5538 23.3371L36.9849 25.8393C37.0937 26.0318 37.0937 26.2744 36.9849 26.4669C36.8761 26.6594 36.6669 26.7766 36.4409 26.7766H35.3614C35.2442 26.7766 35.1521 26.8686 35.1521 26.9858V29.4964C35.1521 29.6135 35.2442 29.7056 35.3614 29.7056H37.8719C38.215 29.7056 38.4996 29.9901 38.4996 30.3332V32.8438C38.4996 34.5761 37.0937 35.982 35.3614 35.982ZM35.0684 34.7267H35.3614C36.3991 34.7267 37.2443 33.8815 37.2443 32.8438V30.9609H35.3614C34.558 30.9609 33.8968 30.2997 33.8968 29.4964V26.9858C33.8968 26.1824 34.5496 25.5213 35.3614 25.5213L34.4659 23.9563C34.2818 23.63 33.9303 23.4291 33.5537 23.4291H32.6416V28.6595C32.6416 29.9315 31.6122 30.9609 30.3402 30.9609H21.7624V32.8438C21.7624 33.8815 22.6076 34.7267 23.6453 34.7267H23.9382C24.2144 33.7643 25.1014 33.053 26.1559 33.053C27.2103 33.053 28.0974 33.7643 28.3736 34.7267H30.6414C30.9176 33.7643 31.8047 33.053 32.8591 33.053C33.9136 33.053 34.7923 33.7643 35.0684 34.7267Z",
    fill: "#1D244A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1559 37.6555C24.8838 37.6555 23.8545 36.6261 23.8545 35.3541C23.8545 34.0821 24.8838 33.0527 26.1559 33.0527C27.4279 33.0527 28.4572 34.0821 28.4572 35.3541C28.4572 36.6261 27.4279 37.6555 26.1559 37.6555ZM26.1559 34.308C25.5784 34.308 25.1098 34.7767 25.1098 35.3541C25.1098 35.9315 25.5784 36.4002 26.1559 36.4002C26.7333 36.4002 27.2019 35.9315 27.2019 35.3541C27.2019 34.7767 26.7333 34.308 26.1559 34.308Z",
    fill: "#1D244A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8507 37.6555C31.5787 37.6555 30.5493 36.6261 30.5493 35.3541C30.5493 34.0821 31.5787 33.0527 32.8507 33.0527C34.1227 33.0527 35.152 34.0821 35.152 35.3541C35.152 36.6261 34.1227 37.6555 32.8507 37.6555ZM32.8507 34.308C32.2732 34.308 31.8046 34.7767 31.8046 35.3541C31.8046 35.9315 32.2732 36.4002 32.8507 36.4002C33.4281 36.4002 33.8968 35.9315 33.8968 35.3541C33.8968 34.7767 33.4281 34.308 32.8507 34.308Z",
    fill: "#1D244A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8718 30.9611H35.3612C34.5578 30.9611 33.8967 30.3 33.8967 29.4966V26.986C33.8967 26.1826 34.5578 25.5215 35.3612 25.5215H36.4408C36.6667 25.5215 36.876 25.6386 36.9847 25.8395L38.4158 28.3501C38.466 28.4421 38.4995 28.5509 38.4995 28.6597V30.3334C38.4995 30.6765 38.2149 30.9611 37.8718 30.9611ZM35.3612 26.7768C35.2441 26.7768 35.152 26.8688 35.152 26.986V29.4966C35.152 29.6137 35.2441 29.7058 35.3612 29.7058H37.2442V28.8271L36.0726 26.7768H35.3612Z",
    fill: "#1D244A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1004_228075",
    x: 0.853027,
    y: 0.00976562,
    width: 55.8655,
    height: 55.8652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1004_228075"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1004_228075",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocationMarker);
export default __webpack_public_path__ + "static/media/current_location_marker.756565e10c24c75d2730530c90e4a794.svg";
export { ForwardRef as ReactComponent };